import { useState } from 'react';
import { createPortal, flushSync } from 'react-dom';
import { AppLoaderPage } from '@gokrew/ui/components/AppLoaderPage';
import { LoaderContext } from './LoaderContext';

export function LoaderProvider({ children }: { children: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);

  const startNavigationLoading = () => {
    flushSync(() => setIsLoading(true));
  };

  const stopNavigationLoading = () => {
    // Defer by one frame so the new page renders with the loader on top for
    // at least one paint before it disappears, preventing a flash of content.
    requestAnimationFrame(() => setIsLoading(false));
  };

  return (
    <LoaderContext.Provider value={{ startNavigationLoading, stopNavigationLoading }}>
      {children}
      {isLoading &&
        createPortal(
          <div className="fixed inset-0 z-9999">
            <AppLoaderPage />
          </div>,
          document.body,
        )}
    </LoaderContext.Provider>
  );
}
